import { useEmployeeStatuses } from "../components/employees";
import useEmissionsContext from "../contexts/emissions";
import { useAccountData } from "../firebase";
import useAccountingData from "../hooks/accountingData";

import { findAccountingBlockers } from "./accountingBlockers";

export const useFindAccountingBlockingEmissions = () => {
  const { allEmissions } = useEmissionsContext();
  const [{ startDate, employeeCount }] = useAccountData();
  const [{ mostRecentAccountingDate }] = useAccountingData();
  const [employees] = useEmployeeStatuses();

  return (accountingDate) =>
    findAccountingBlockers({
      allEmissions,
      startDate,
      employeeCount,
      mostRecentAccountingDate,
      employees,
      accountingDate
    });
};
